import { analytics } from '../service';

export type DownloadAppButtonSource =
  | 'swipe_balance_limit_modal'
  | 'reveal_balance_limit_modal'
  | 'play_now_limit_modal'
  | 'download_modal_store_badge_google'
  | 'download_modal_store_badge_apple'
  | 'qr_widget_store_badge_google'
  | 'qr_widget_store_badge_apple';

export interface TrackDownloadAppButtonClickedParams {
  source: DownloadAppButtonSource;
}

export function trackDownloadAppButtonClicked(
  params: TrackDownloadAppButtonClickedParams,
): void {
  analytics.captureEvent('Duos Download App Button Clicked', {
    source: params.source,
  });
}
